import { useState } from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const DeleteJournalModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  promptId,
  journalTitle,
  setShowSuccess,
  setShowError,
  setErrorMsg
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    { url: `journal/deletePrompt/${promptId}`, method: "delete" },
    { manual: true }
  );

  const onConfirmDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        setShowSuccess?.(true);
        setTimeout(() => setShowSuccess?.(false), 5000);
        return true;
      }
    } catch (error) {
      const data = error?.response?.data;
      // iGrad.api returns validation failures as Response<T>: { errors: [{ errorMessage }] }
      const responseErrors = Array.isArray(data?.errors)
        ? data.errors.map((e) => e.errorMessage || e.ErrorMessage).filter(Boolean).join(" ")
        : null;
      const apiMessage =
        responseErrors || data?.message || (typeof data === "string" ? data : null) || error?.message;
      const resolvedMessage =
        apiMessage ||
        "Unable to delete this journal. Please ensure it is not in use and try again.";

      setErrorMessage(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    }
    return false;
  };

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={onConfirmDelete}
      resourceName={journalTitle}
      resourceType="journal"
      confirmationValue={journalTitle || "delete"}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteJournalModal;